<template>
  <div class="contact-page">
    <HeaderComp></HeaderComp>
    <main class="center-container">
      <div class="contact-layout">
        <div class="form-container about-card">
          <h1>Meist</h1>
          <p>
            Oleme üle 20 aasta tegutsenud ettevõte, mis seoses omaniku vahetusega
            on muutnud oma nime. Meie põhitegevuseks on uute ja kasutatud rehvide
            ning velgede müük nii sõidu- kui ka veoautodele.
          </p>
          <p>
            Lisaks pakume klientidele professionaalset montaaži, rehivahetust ja
            rehviremonti. Samuti oleme üks vähestest Pärnumaa ettevõtetest, kes
            tegeleb rasketehnika rehvide täitmisega erinevate ballastvedelikega.
          </p>
        </div>

        <div class="form-container contact-card">
          <h1>Kontaktid</h1>
          <div class="contact-info">
            <a href="mailto:mlrehvid@gmail.com" class="contact-chip">
              <span class="chip-label">E-post</span>
              mlrehvid@gmail.com
            </a>
            <a href="tel:+3725104951" class="contact-chip">
              <span class="chip-label">Telefon</span>
              +372 5104951
            </a>
          </div>
          <div class="contact-sections">
            <div class="hours">
              <h2>Lahtiolekuajad</h2>
              <ul class="hours-list">
                <li>
                  <span class="day">esmaspäev</span
                  ><span class="time">08–16:30</span>
                </li>
                <li>
                  <span class="day">teisipäev</span
                  ><span class="time">08–16:30</span>
                </li>
                <li>
                  <span class="day">kolmapäev</span
                  ><span class="time">08–16:30</span>
                </li>
                <li>
                  <span class="day">neljapäev</span
                  ><span class="time">08–16:30</span>
                </li>
                <li>
                  <span class="day">reede</span><span class="time">08–16:30</span>
                </li>
                <li>
                  <span class="day">laupäev</span><span class="time">10–14:00</span>
                </li>
                <li>
                  <span class="day">pühapäev</span
                  ><span class="time closed">Suletud</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section class="form-container iframe-container">
        <h1>Aadress: Riia mnt 233a/6, 80042 Pärnu</h1>
        <div class="iframe-wrapper">
          <iframe
            class="rounded-iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16742.712769094212!2d24.55453157732921!3d58.36151938810984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46ecfc91ab77920d%3A0xaf6f44c4df01462c!2sML%20Rehvid!5e0!3m2!1set!2see!4v1738853029498!5m2!1set!2see"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </main>
    <FooterComp></FooterComp>
  </div>
</template>

<script>
import HeaderComp from "@/components/HeaderComp.vue";
import FooterComp from "@/components/FooterComp.vue";

export default {
  name: "ContactUs",
  components: {
    HeaderComp,
    FooterComp,
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Alata&display=swap");

* {
  font-family: "Alata", sans-serif;
}

.contact-page {
  min-height: 100vh;
  background: #151217;
}

.center-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background:
    linear-gradient(180deg, #151217 0, #151217 96px, #fff7fb 96px, #ffffff 100%);
  padding: 44px 20px 66px 20px;
  box-sizing: border-box;
}

.contact-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.12fr) minmax(320px, 0.88fr);
  gap: 18px;
  width: min(100%, 1180px);
  align-items: stretch;
}

.form-container {
  width: 100%;
  padding: 28px;
  background: #ffffff;
  border: 1px solid #f0bdd3;
  border-radius: 8px;
  box-shadow: 0 26px 64px rgba(42, 22, 34, 0.13);
  box-sizing: border-box;
  margin-bottom: 18px;
}

.about-card {
  background:
    linear-gradient(135deg, #211820 0%, #211820 38%, #3d2031 100%);
  color: #fff7fb;
  border-color: rgba(255, 137, 195, 0.36);
}

.form-container h1,
.form-container h2 {
  margin: 0 0 12px 0;
  color: #211820;
}

.form-container h1 {
  position: relative;
  font-size: clamp(1.85rem, 4vw, 3.1rem);
  line-height: 1.02;
  border-bottom: 0;
  padding-bottom: 16px;
  font-weight: 800;
}

.form-container h1::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: min(180px, 62vw);
  height: 5px;
  background: #e22289;
}

.form-container h2 {
  font-size: 1.35rem;
  line-height: 1.3;
  color: #211820;
}

.form-container p {
  font-size: 1.06rem;
  line-height: 1.75;
  color: #3f3740;
  margin: 18px 0 0 0;
}

.form-container.about-card h1,
.form-container.about-card p {
  color: #fff7fb;
}

.iframe-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: min(100%, 1180px);
  padding: 0;
  overflow: hidden;
}

.iframe-container > h1 {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin: 0;
  padding: 24px 28px 18px;
  font-size: clamp(1.6rem, 3.5vw, 3.1rem);
  line-height: 1.08;
  overflow-wrap: break-word;
}

.iframe-container > h1::after {
  left: 28px;
  width: min(180px, calc(100% - 56px));
}

@media (max-width: 768px) {
  .center-container {
    padding: 20px 10px 40px 10px;
    overflow-x: hidden;
    background:
      linear-gradient(180deg, #151217 0, #151217 54px, #fff7fb 54px, #ffffff 100%);
  }

  .contact-layout {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .form-container {
    padding: 18px;
  }
  .form-container h1 {
    font-size: clamp(1.75rem, 10vw, 2.5rem);
  }
  .form-container h2 {
    font-size: 1.25rem;
  }
  .form-container p {
    font-size: 1.05rem;
    line-height: 1.7;
  }
}

@media (max-width: 560px) {
  .center-container {
    align-items: flex-start;
  }

  .contact-layout,
  .iframe-container {
    max-width: 370px;
    margin-left: 0;
    margin-right: auto;
  }
}

.iframe-wrapper {
  position: relative;
  width: 100%;
  height: min(56vw, 560px);
  min-height: 390px;
  margin-top: 14px;
}

.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0 0 8px 8px;
}

.rounded-iframe {
  border-radius: 0 0 8px 8px;
}

.contact-card {
  border-color: #f0bdd3;
  background:
    linear-gradient(180deg, #ffffff 0%, #fff8fc 100%);
}

.contact-info {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 6px 0 12px 0;
}

.contact-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 13px;
  border-radius: 7px;
  background: #ffffff;
  border: 1px solid #ead4df;
  color: #211820;
  text-decoration: none;
  font-weight: 600;
  box-shadow: 0 10px 22px rgba(42, 22, 34, 0.06);
}

.contact-chip:hover {
  background: #fff0f7;
  border-color: #e22289;
}

.chip-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: #c01672;
}

.contact-sections {
  display: grid;
  grid-template-columns: 1fr; /* Can be expanded later */
  gap: 16px;
}

.hours h2 {
  margin: 18px 0 12px 0;
  font-size: 1.35rem;
  color: #211820;
}

.hours-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.hours-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 11px 12px;
  border-radius: 7px;
  background: #ffffff;
  border: 1px solid #f0d8e4;
  margin-bottom: 8px;
}

.hours-list .day {
  font-weight: 600;
  color: #211820;
}

.hours-list .time {
  font-weight: 600;
  color: #211820;
  padding: 4px 10px;
  border-radius: 6px;
  background: #fff0f7;
  border: 1px solid #ead4df;
}

.hours-list .time.closed {
  background: #ffe8e8;
  border-color: #ffc4c4;
  color: #9b1c1c;
}

@media (max-width: 768px) {
  .contact-sections {
    grid-template-columns: 1fr;
  }
  .hours h2 {
    font-size: 1.25rem;
  }

  .contact-info {
    flex-direction: column;
  }

  .contact-chip {
    width: 100%;
    box-sizing: border-box;
  }

  .hours-list li {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .iframe-wrapper {
    height: 340px;
    min-height: 300px;
  }

  .iframe-container {
    padding: 0;
  }
}

@media (max-width: 560px) {
  .center-container {
    align-items: flex-start;
  }

  .contact-layout,
  .iframe-container {
    width: calc(100% - 20px);
    max-width: 370px;
    margin-left: 0;
    margin-right: auto;
  }

  .iframe-container > h1 {
    padding: 18px 18px 14px;
    font-size: clamp(1.45rem, 7vw, 2rem);
    line-height: 1.12;
  }

  .iframe-container > h1::after {
    left: 18px;
    width: min(180px, calc(100% - 36px));
  }
}
</style>
